import React, { useContext } from 'react'
import { getLanguageLocale, getMarket, CircleSpinner } from 'shared/index'
import {
	initiateUserUpdate,
	ContactInfoChangeType,
} from 'selfServicePortal/services/CustomerServices/updateUserService'
import { FormBuilder } from '@tf/formbuilder'
import { Heading } from 'selfServicePortal/components'
import { FormWrapper } from 'shared/formBuilder/formWrapper'
import { useTranslation } from 'react-i18next'
import SspContext from 'selfServicePortal/contexts/SspContext'
import { ICustomer } from 'selfServicePortal/interfaces/i-api-customer'
import { ISubmitCustomerInformation } from '../MyAccount'
import { AccountMobilePhoneFormDE_AT } from 'shared/formBuilder/forms/customerInformationFormDE_AT'
import { useMutation } from '@tanstack/react-query'
import { getErrorMessage } from 'selfServicePortal/utils'
import { OtpDistributionChannel } from 'selfServicePortal/interfaces/i-api-sdd'

function deriveMobilePhoneForm(formMeta: any, data: any) {
	return FormWrapper([AccountMobilePhoneFormDE_AT(data)], formMeta)
}

interface PhoneFormProps {
	onSuccess: (sessionId: string) => void
}

export function PhoneForm({ onSuccess }: PhoneFormProps) {
	const { t } = useTranslation()
	const { customerData } = useContext(SspContext)
	const initiateUserUpdateMutation = useMutation(
		(formData: ICustomer) =>
			initiateUserUpdate({
				customerId: customerData?.customerId,
				firstName: customerData?.firstName,
				lastName: customerData?.lastName,
				market: getMarket(),
				phoneNumber: formData.mobilePhoneNumber,
				newContactDetail: formData.mobilePhoneNumber,
				changeType: ContactInfoChangeType.PhoneNumber,
				distributionChannel: OtpDistributionChannel.SMS,
			}),
		{
			onSuccess: ({ sessionId }) => onSuccess(sessionId),
		},
	)

	const mobilePhoneFormSchema = deriveMobilePhoneForm(
		{
			formName: 'mobilePhone',
			blockName: 'mobilePhone',
			market: getMarket(),
			locale: getLanguageLocale(),
			getDataUrl: '',
			validationErrorList: false,
			requiredMessage: t('ValidateRequired'),
			submitButtonText: t('Save'),
		},
		customerData,
	)

	if (initiateUserUpdateMutation.isLoading) {
		return <CircleSpinner />
	}

	return (
		<>
			<Heading
				title={t('<Title Here>')}
				description={t('<Desctiption Here>')}
			/>

			<FormBuilder
				formSchema={mobilePhoneFormSchema}
				apiError={undefined}
				showErrorsInForm={true}
				showSubmitButton={true}
				onSubmit={(values: ISubmitCustomerInformation) =>
					initiateUserUpdateMutation.mutate(values.customer)
				}
			/>

			{initiateUserUpdateMutation.isError && (
				<div className="error-msg">
					{getErrorMessage(initiateUserUpdateMutation.error)}
				</div>
			)}
		</>
	)
}
